import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import usePageTitle from '../hooks/usePageTitle';

function PrivacyPolicyPage() {
  usePageTitle('Privacy Policy');

  const hasDownloaded = useRef(false);

  useEffect(() => {
    // Only trigger download once, even if component mounts multiple times (e.g., in React Strict Mode)
    if (!hasDownloaded.current) {
      hasDownloaded.current = true;
      const link = document.createElement('a');
      link.href = '/privacy-policy.pdf';
      link.download = 'privacy-policy.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, []);

  // The App Store privacy link lands here, and a browser that blocks the
  // download leaves the visitor on this page, so it carries the site
  // navigation rather than three lines of text on an empty screen.
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-16 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-lg w-full text-center">
          <h1
            className="text-4xl font-bold mb-4"
            style={{ color: '#a60533' }}
          >
            Privacy Policy
          </h1>
          <p className="text-gray-600 mb-2">
            Your download should start automatically.
          </p>
          <p className="text-gray-600 mb-8">
            If the download does not start,{' '}
            <a
              href="/privacy-policy.pdf"
              download
              className="underline"
              style={{ color: '#a60533' }}
            >
              open the policy
            </a>
            .
          </p>
          <Link
            to="/"
            className="inline-flex items-center text-gray-600 hover:text-gray-800 transition-colors"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
